// Polyfill: requestIdleCallback (not supported in older Safari / iOS 15-)
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (cb, opts) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () { return Math.max(0, 50 - (Date.now() - start)); }
      });
    }, (opts && opts.timeout) ? Math.min(opts.timeout, 1) : 1);
  };
  window.cancelIdleCallback = clearTimeout;
}

document.addEventListener("DOMContentLoaded", () => {
  /**
   * 🔹 Initialize swatches
   */
  function initializeSwatches(scope = document) {
    const swatchBlocks = scope.querySelectorAll(".card-wrapper .color-swatches");
    if (!swatchBlocks.length) return;

    for (const block of swatchBlocks) {
      const btns = block.querySelectorAll(".quick-add__submit.button:not([aria-haspopup])");
      btns.forEach(btn => btn.setAttribute("aria-haspopup", "dialog"));

      const firstLabel = block.querySelector(".swatch-label");
      if (!firstLabel) continue;

      const swatch = firstLabel.querySelector(".swatch");
      const selectedColor = swatch?.getAttribute("title");
      const wishlistButton = block.closest(".card-wrapper")?.querySelector(".wishlist_button");

      if (wishlistButton && selectedColor) {
        wishlistButton.dataset.selectedVariantValue = selectedColor;
      }

      firstLabel.classList.add("active");
      const radio = firstLabel.querySelector(".swatch-radio");
      if (radio) {
        radio.checked = true;
      }
    }
  }

  /**
   * 🕐 Wait for swatches to exist before initializing
   */
  function waitForSwatches(scope = document, retries = 10) {
    requestIdleCallback(() => {
      const swatches = scope.querySelectorAll(".card-wrapper .color-swatches .swatch-label");
      if (swatches.length) {
        initializeSwatches(scope);
      } else if (retries > 0) {
        setTimeout(() => waitForSwatches(scope, retries - 1), 100);
      }
    }, { timeout: 500 });
  }

  /**
   * 🖼️ Non-blocking variant image change
   */
  const updateVariantImage = (cardWrapper, variant) => {
    if (!variant?.variant_image?.length || !variant?.variant_image[0]) return;
    const primaryImage = variant.variant_image[0];
    const images = cardWrapper.querySelectorAll(".main-img");
    if (!images.length) return;

    const generateSrcSet = (url) => {
      const widths = [165, 360, 533, 720, 940, 1066, 1710];
      return widths.map(w => `${url}&width=${w} ${w}w`).join(", ");
    };
    const srcset = generateSrcSet(primaryImage);

    requestAnimationFrame(() => {
      images.forEach(img => {
        img.src = `${primaryImage}&width=533`;
        img.srcset = srcset;
        img.sizes = "(min-width: 768px) 533px, 100vw";
      });
    });
  };

  /**
   * 🧠 Swatch click delegation (lightweight, global)
   */
  document.addEventListener("click", (e) => {
    const label = e.target.closest(".card-wrapper .color-swatches .swatch-label");
    if (!label) return;

    const card = label.closest(".card-wrapper");
    const radio = label.querySelector(".swatch-radio");
    const variantId = radio?.value;
    const color = label.querySelector(".swatch")?.getAttribute("title");

    // Update active states
    label.parentElement.querySelectorAll(".swatch-label").forEach(l => l.classList.remove("active"));
    label.classList.add("active");

    const form = card?.querySelector(".card_product_add_to_card form");
    const input = form?.querySelector("input[name='id']");
    const wishlistBtn = card?.querySelector(".wishlist_button");
    const addBtn = card?.querySelector(".quick-add__submit.button");

    if (input && variantId) input.value = variantId;
    if (wishlistBtn && variantId) {
      wishlistBtn.dataset.productVariantId = variantId;
      if (color) wishlistBtn.dataset.selectedVariantValue = color;
    }
    if (addBtn) addBtn.disabled = !variantId;

    // Change image after idle
    const jsonData = card?.querySelector("#product-variants-data")?.textContent;
    if (jsonData && variantId) {
      requestIdleCallback(() => {
        try {
          const variants = JSON.parse(jsonData);
          const variant = variants.find(v => v.id == variantId);
          updateVariantImage(card, variant);
        } catch (err) {
          console.warn("⚠️ Variant JSON parse failed:", err);
        }
      });
    }
  });

  /**
   * 🔁 Observe product grid (Infinite scroll / AJAX)
   */
  function observeInfiniteScroll() {
    const grid = document.querySelector(".product-grid");
    if (!grid) return;

    const observer = new MutationObserver((mutations) => {
      let newProducts = false;
      for (const m of mutations) {
        // Check classList only — no querySelector inside observer callbacks
        if ([...m.addedNodes].some(n =>
          n.nodeType === 1 && (
            n.classList.contains('card-wrapper') ||
            n.classList.contains('card-product-swiper') ||
            n.classList.contains('grid__item')
          )
        )) {
          newProducts = true;
          break;
        }
      }

      if (newProducts) {
        requestIdleCallback(() => {
          waitForSwatches(grid);
          initCardSwiperTouch();
        }, { timeout: 800 });
      }
    });

    observer.observe(grid, { childList: true, subtree: false });
    requestIdleCallback(() => waitForSwatches(grid), { timeout: 400 });
  }

  /**
   * 🧩 Handle Shopify dynamic section reloads
   */
  document.addEventListener("shopify:section:load", (e) => waitForSwatches(e.target));

  /**
   * 🚀 Start observers after short delay
   */
  setTimeout(() => {
    waitForSwatches(document);
    observeInfiniteScroll();
  }, 300);
});

// ============================================
// Card Product Swiper - Vanilla JS
// Infinite loop scroll + auto scroll on hover
// Layout: [clone-last | real-0 ... real-(n-1) | clone-first]
//          index 0      index 1   ...  index n   index n+1
// ============================================
function cardSwiperGoTo(swiperEl, index, skipTransition) {
  var track = swiperEl.querySelector('.card-swiper-track');
  var total = swiperEl._total;
  if (!track || !total) return;

  // Cancel any pending loop-jump listener
  if (swiperEl._loopEndListener) {
    track.removeEventListener('transitionend', swiperEl._loopEndListener);
    swiperEl._loopEndListener = null;
  }

  if (skipTransition) {
    swiperEl._current = index;

    track.style.transition = 'none';
    track.style.transform =
      'translate3d(-' + (index * 100) + '%,0,0)';

    // force browser repaint
    void track.offsetHeight;

    // restore transition
    track.style.transition =
      'transform .45s cubic-bezier(.22,.61,.36,1)';

    return;
  }

  swiperEl._current = index;
  track.style.transform =
    'translate3d(-' + (index * 100) + '%,0,0)';

  // if (skipTransition) {
  //   track.style.transition = '';
  // }

  // Map loop index → real index for the progress bar
  var realIndex = index - 1;
  if (realIndex < 0) realIndex = total - 1;
  if (realIndex >= total) realIndex = 0;

  var card = swiperEl.closest('.card-wrapper') || swiperEl.closest('.card__inner') || swiperEl.parentElement;
  var dotsBar = card && card.querySelector('.card-swiper-dots');
  if (dotsBar && total > 1) {
    dotsBar.style.setProperty('--swiper-thumb-w', (1 / total * 100).toFixed(2) + '%');
    dotsBar.style.setProperty('--swiper-thumb-x', (realIndex / total * 100).toFixed(2) + '%');
  }

  // After the slide transition: if we landed on a clone, silently jump to the real slide
  if (!skipTransition) {
    var onEnd = function () {
      track.removeEventListener('transitionend', onEnd);
      swiperEl._loopEndListener = null;
      if (swiperEl._current === 0) {
        cardSwiperGoTo(swiperEl, total, true);       // was clone-last  → jump to real last
      } else if (swiperEl._current === total + 1) {
        cardSwiperGoTo(swiperEl, 1, true);            // was clone-first → jump to real first
      }
    };
    swiperEl._loopEndListener = onEnd;
    track.addEventListener('transitionend', onEnd, { once: true });
  }
}

function cardSwiperPrev(btn) {
  var swiper = btn.closest('.card-product-swiper');
  if (!swiper._total) return;
  cardSwiperGoTo(swiper, (swiper._current || 1) - 1);
}

function cardSwiperNext(btn) {
  var swiper = btn.closest('.card-product-swiper');
  if (!swiper._total) return;
  cardSwiperGoTo(swiper, (swiper._current || 1) + 1);
}

function initCardSwiperTouch() {
  document.querySelectorAll('.card-product-swiper:not([data-touch-init])').forEach(function (swiper) {
    swiper.setAttribute('data-touch-init', '1');

    var track = swiper.querySelector('.card-swiper-track');
    var origSlides = Array.from(swiper.querySelectorAll('.card-swiper-slide'));
    var total = origSlides.length;
    if (!track || total <= 1) return;

    swiper._total = total;

    // ── Build infinite-loop clones ──
    var firstClone = origSlides[0].cloneNode(true);
    var lastClone = origSlides[total - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.appendChild(firstClone);                   // index total+1
    track.insertBefore(lastClone, origSlides[0]);    // index 0

    // Start at real index 1 (no animation)
    swiper._current = 1;
    track.style.transition = 'none';
    track.style.transform = 'translate3d(-100%,0,0)';
    void track.offsetWidth;
    track.style.transition =
      'transform .45s cubic-bezier(.22,.61,.36,1)';

    // Init progress bar
    var card = swiper.closest('.card-wrapper') || swiper.closest('.card__inner') || swiper.parentElement;
    var dotsBar = card && card.querySelector('.card-swiper-dots');
    if (dotsBar) {
      dotsBar.style.setProperty('--swiper-thumb-w', (1 / total * 100).toFixed(2) + '%');
      dotsBar.style.setProperty('--swiper-thumb-x', '0%');
    }

    // Both arrows always visible in loop mode
    var prevBtn = swiper.querySelector('.card-swiper-prev');
    var nextBtn = swiper.querySelector('.card-swiper-next');
    if (prevBtn) prevBtn.classList.remove('is-hidden');
    if (nextBtn) nextBtn.classList.remove('is-hidden');

    var autoInterval = null;
    var mediaEl = swiper.closest('.card__media');

    // ── Hover auto-scroll (loops forever) ──
    if (mediaEl) {
      mediaEl.addEventListener('mouseenter', function () {
        clearInterval(autoInterval);
        autoInterval = setInterval(function () {
          cardSwiperGoTo(swiper, swiper._current + 1);
        }, 1200);
      });
      mediaEl.addEventListener('mouseleave', function () {
        clearInterval(autoInterval);
        autoInterval = null;
      });
    }

    // ── Shared drag state ──
    var startX = 0, startY = 0;
    var dragging = false, dirLocked = false, isHorizontal = false, didRealDrag = false;

    function dragStart(x, y) {
      startX = x; startY = y;
      dragging = true; dirLocked = false; isHorizontal = false; didRealDrag = false;
      clearInterval(autoInterval); autoInterval = null;
      if (swiper._loopEndListener) {
        track.removeEventListener('transitionend', swiper._loopEndListener);
        swiper._loopEndListener = null;
      }
      track.style.transition = 'none';
    }

    function dragMove(x, y) {
      if (!dragging) return;
      var dx = x - startX, dy = y - startY;
      if (!dirLocked) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        isHorizontal = Math.abs(dx) >= Math.abs(dy);
        dirLocked = true;
      }
      if (!isHorizontal) return;
      didRealDrag = true;
      var base = -(swiper._current || 1) * swiper.offsetWidth;
      track.style.transform =
        'translate3d(' + (base + dx) + 'px,0,0)';
    }

    function dragEnd(x) {
      if (!dragging) return;
      dragging = false;
      track.style.transition =
        'transform .45s cubic-bezier(.22,.61,.36,1)';
      if (!isHorizontal || !didRealDrag) { cardSwiperGoTo(swiper, swiper._current); return; }
      var diff = startX - x;
      var cur = swiper._current || 1;
      cardSwiperGoTo(swiper, Math.abs(diff) > 40 ? (diff > 0 ? cur + 1 : cur - 1) : cur);
    }

    // ── Touch ──
    swiper.addEventListener('touchstart', function (e) {
      dragStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    swiper.addEventListener('touchmove', function (e) {
      dragMove(e.touches[0].clientX, e.touches[0].clientY);
      if (isHorizontal && dirLocked) e.preventDefault();
    }, { passive: false });

    swiper.addEventListener('touchend', function (e) {
      dragEnd(e.changedTouches[0].clientX);
    }, { passive: true });

    // ── Mouse ──
    swiper.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      dragStart(e.clientX, e.clientY);

      function onMove(e) { dragMove(e.clientX, e.clientY); }
      function onUp(e) {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        dragEnd(e.clientX);
      }
      document.addEventListener('mousemove', onMove, { passive: true });
      document.addEventListener('mouseup', onUp, { once: true });
    });

    // Block card link click after a real drag
    swiper.addEventListener('click', function (e) {
      if (didRealDrag) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });
}

document.addEventListener('DOMContentLoaded', initCardSwiperTouch);
document.addEventListener('shopify:section:load', initCardSwiperTouch);
document.addEventListener('collection:updated', initCardSwiperTouch);

// Global observer — catches any dynamic content (related products, recently viewed, etc.)
(function () {
  var pending = false;
  function scheduleInit() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      initCardSwiperTouch();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        // Only check classList — never do n.querySelector() inside MutationObserver
        // (querySelector on every added node is an O(n) deep scan and blocks the main thread)
        if (
          n.classList.contains('card-product-swiper') ||
          n.classList.contains('card-wrapper') ||
          n.classList.contains('product-grid') ||
          n.classList.contains('card__media')
        ) {
          scheduleInit();
          return;
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
}());